import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Card, CardHeader, CardContent, Typography } from '@mui/material';

export default function BankAccountNumber() {
  const { order } = useSelector(state => state.orderData);

  return (
    <Stack direction="row" spacing={2} sx={{ m: 2 }}>
      <Card sx={{ flex: '1 1 35%' }}>
        <CardContent>
          <Stack direction="row" spacing={2}>
            <Typography variant="body2">Numer indywidualnego konta bankowego: </Typography>
            <Typography variant="subtitle2">{order.individual_bank_account_number}</Typography>
          </Stack>
        </CardContent>
      </Card>
      <Box flex="1 1 65%"/>
    </ Stack>
  );
};
